module.exports = __webpack_public_path__ + "images/emoji/station.e5d076862ec68f2e2fe5.png";